<script lang="ts">
  import modal from '$lib/stores/modal-state'
  import sherpa from '$lib/stores/sherpa'
  import { track } from 'src/utils/track'
  import { onMount } from 'svelte'

  export let url: string | null = null

  function finishLoadingSherpaIframe() {
    sherpa.setLoading(false)
  }

  onMount(() => {
    sherpa.setLoading(true)
    document.querySelector('body').style.overflow = 'hidden'
    return () => {
      sherpa.setLoading(false)
      document.querySelector('body').style.overflow = 'unset'
    }
  })

  function handleMessage(message: MessageEvent) {
    let data = message.data
    if (typeof message.data === 'string') {
      try {
        data = JSON.parse(message.data)
      } catch {
        // noop
      }
    }
    if (data?.type === 'modalClose' && data?.source?.startsWith('@joinsherpa')) {
      track('Sherpa iFrame Closed', {
        url: url,
      })
      modal.close()
    } else {
      track('Sherpa iFrame Message', {
        url: url,
        message: data,
      })
    }
  }
</script>

<svelte:window on:message={handleMessage} />

<div
  class="fixed inset-0 z-50 w-screen h-screen p-0 m-0 overflow-auto overscroll-none pointer-events-none"
>
  <iframe
    src={url}
    class="absolute inset-0 w-screen h-screen p-0 m-0 pointer-events-auto"
    frameborder="0"
    title="Sherpa"
    on:load={finishLoadingSherpaIframe}
  />
</div>
